import { isString } from '@/utils/validate'
import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useKeepAliveStore = defineStore('keep-alive', () => {
  const cachedRoutes = ref([])

  const addCachedRoute = route => {
    const keepAlive = route.meta.keepAlive
    const name = route.name
    if (keepAlive && name && isString(name) && !cachedRoutes.value.includes(name)) {
      cachedRoutes.value.push(name)
    }
  }

  const delAllCachedRoutes = () => {
    cachedRoutes.value = []
  }
  // 删除特定页面的单个缓存
  /**
   * Removes a route name from the cachedRoutes array if it exists.
   * @param {Object} route - The route object containing the name to be removed.
   */
  const delCachedView = route => {
    const index = cachedRoutes.value.indexOf(route.name)
    if (index > -1) {
      cachedRoutes.value.splice(index, 1)
    }
  }

  return { cachedRoutes, addCachedRoute, delAllCachedRoutes, delCachedView }
})
